/**
 * Favorites Controller
 * Handles adding/removing favorites and updating UI state
 */
export class FavoritesController {
  constructor(storageService, options = {}) {
    this.storage = storageService;
    this.onFavoritesChange = options.onFavoritesChange || (() => {});
    this.favorites = [];
  }

  async init() {
    this.favorites = await this.storage.getFavorites();
    this._bindEvents();
    this._updateAllFavoriteButtons();
  }

  _bindEvents() {
    // Use event delegation on the document for favorite buttons
    document.addEventListener('click', async (e) => {
      const favoriteBtn = e.target.closest('.favorite-btn');
      if (!favoriteBtn) return;

      e.preventDefault();
      e.stopPropagation();

      const appId = favoriteBtn.dataset.appId;
      if (!appId) return;

      await this.toggleFavorite(appId);
    });
  }

  async toggleFavorite(appId) {
    const isFavorite = this.favorites.includes(appId);

    if (isFavorite) {
      this.favorites = await this.storage.removeFavorite(appId);
    } else {
      this.favorites = await this.storage.addFavorite(appId);
    }

    this._updateAllFavoriteButtons();
    this.onFavoritesChange(this.favorites, appId, !isFavorite);
  }

  _updateAllFavoriteButtons() {
    const buttons = document.querySelectorAll('.favorite-btn');
    buttons.forEach(btn => {
      const appId = btn.dataset.appId;
      const isFavorite = this.favorites.includes(appId);
      btn.classList.toggle('is-favorite', isFavorite);

      const icon = btn.querySelector('i');
      if (icon) {
        icon.className = isFavorite ? 'bi bi-star-fill' : 'bi bi-star';
      }
    });
  }

  isFavorite(appId) {
    return this.favorites.includes(appId);
  }

  getFavorites() {
    return this.favorites;
  }
}
